<template>
    <v-dialog v-model="dialog" width="850" persistent>
        <v-card max-height="80vh" tile>
            <v-toolbar color="white">
                <v-toolbar-title class="text-primary">ثبت روز های مرخصی</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon size="23" color="primary">close</v-icon>
                </v-btn>
            </v-toolbar>
            <div class="px-4 pt-3">
                <v-row align="center" >
                    <v-col md="auto" cols="12">
                        <v-date-picker
                            color="secondary"
                            show-adjacent-months
                            multiple
                            hide-header
                            v-model="dates"
                        ></v-date-picker>
                    </v-col>
                    <v-divider vertical inset class="d-none d-md-block"></v-divider>
                    <v-col cols="12" md>
                        <div class="overflow-y-auto" style="height: 400px; scrollbar-width:thin">
                            <div v-for="(key,index0) in Object.keys(calcLeaves)" :key="index0">
                                <div class="d-flex align-center text-secondary text-meta mt-3 font-weight-bold"><span class="bg-white px-2">{{key}}</span><v-divider color="secondary"></v-divider></div>
                                <v-row class="mt-1 mx-0">
                                    <v-col v-for="(item,index) in calcLeaves[key]" :key="index"  cols="auto">
                                        <div class="px-3 py-1 rounded text-meta text-grey-darken-2 user-select-none" style="background-color:#F5F5F5">
                                            <v-icon @click="()=>{leaveItems.splice(leaveItems.findIndex(x=>x==item),1)}" class="rounded-circle me-1 cursor-pointer" color="grey-darken-2" size="15" style="padding:1px;margin-bottom:2px;background-color:#CCCCCC">clear</v-icon>
                                            <span class="user-select-none">{{ item }}</span>
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </div>
            <v-card-actions class="py-3 px-5 bg-white">
                <v-spacer></v-spacer>
                <v-btn color="success" variant="flat" :loading="loading" @click="setEmployeeLeave">ثبت اطلاعات</v-btn>
                <v-btn color="error" @click="dialog = false">بستن</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
const api = useApi();
const toast = useToastStore();
const moment = useMoment();
const dialog = defineModel();
const user = defineModel('user');
const loading = ref(false);
const leaves = ref([]);
const calcLeaves = computed(() => {
    let leaveItems = [...leaves.value];
    leaveItems.sort();
    let res = {};
    leaveItems.forEach(el => {
        let parsedDate = moment(el, 'YYYY-MM-DD');
        if(!res[parsedDate.format('jMMMM')])
            res[parsedDate.format('jMMMM')] = [];
        res[parsedDate.format('jMMMM')].push(parsedDate.format('jYYYY/jMM/jDD'));
    });
    return res;
})
const dates = computed({
    get: () => leaves.value.map(x => moment(x, 'YYYY-MM-DD')),
    set: (value) => leaves.value = value.map(x => x.format('YYYY-MM-DD'))
});

async function setEmployeeLeave() {
    loading.value = true;
    api.userUpdate(user.value.id, {_method: 'put', leaves: leaves.value, employee: true}).then((res) => {
        if (res && res.status == "UPDATED") {
            toast.success(res.message);
            user.value.leaves = leaves.value;
            dialog.value = false;
        }
    }).finally(()=>{loading.value = false});
}

watch(user, () => {
    leaves.value = user.value.leaves ?? [];
})
</script>
